import React from "react";

interface FrequentlyMentionedProps {
  reviewWords: string[];
  isProductReviewPage?: boolean;
}

const FrequentlyMentioned = ({
  reviewWords,
  isProductReviewPage,
}: FrequentlyMentionedProps) => {
  let containerClass =
    "review-keyword-section py-8 px-6 xs:px-0 xxxl:pl-8 xxxl:pr-0";

  if (isProductReviewPage) {
    containerClass += " xl:border-t-0 grid place-items-center xl:w-1/2";
  }

  return (
    <div className={containerClass}>
      <>
        <h3
          className="text-xl font-semi-bold leading-6 text-gray-800 m-0"
          style={{ lineHeight: 1 }}
        >
          Frequently Mentioned
        </h3>
        <ul className="reviewsFrequentlyMentioned flex m-0 flex-wrap justify-center xs:px-20 xxxl:px-0">
          {reviewWords.map((match) => (
            <li
              key={match}
              className="text-lg leading-none text-gray-600 px-3 pt-4"
            >
              {match}
            </li>
          ))}
        </ul>
      </>
    </div>
  );
};

export default FrequentlyMentioned;
